import { jsx } from "react/jsx-runtime";
import { token } from "./token.js";
import { Thumbnail } from "./Thumbnail.js";
function SkeletonThumbnail({
  size = "m",
  shape = "square",
  ...props
}) {
  return /* @__PURE__ */ jsx(Thumbnail, {
    size,
    shape,
    backgroundColor: token.gray100a,
    icon: "",
    "data-testid": "ds-skeleton-thumbnail",
    ...props
  });
}
export {
  SkeletonThumbnail
};
//# sourceMappingURL=SkeletonThumbnail.js.map
